function e(N,r){return N===r||Number.isNaN(N)&&Number.isNaN(r)}export{e as eq};
